import { gql } from '@apollo/client';
/**
 * @const DeleteEntityReminderMutation
 * @since 1.0.0
 */
export const DeleteEntityReminderMutation = gql `
  mutation DeleteEntityReminderMutation($input: DeleteEntityReminderInput!) {
    deleteEntityReminder(input: $input)
  }
`;
